import React from 'react'

import { InventoryScan } from 'planner-upgrades'
import useStyles from './useStyles'

import 'planner-upgrades/lib/tailwind/theme.css'
import moment from 'moment'
import * as Dialog from '@radix-ui/react-dialog'
import Button from 'planner-upgrades/base/Button'
import InventoryScanDisabled from 'common/components/features/EmptyState/InventoryScanDisabled'
import { getCurrentSubcoId } from 'selectors/profile'
import { useSelector } from 'react-redux'
import { batchHubOut } from 'actions/hubLogs'
import { getIsBatchHubOutDone } from 'selectors/combined'
import { Trans, useTranslation } from 'react-i18next'
import Snowflake from '../../../common/components/base/vectors/Snowflake'
import CheckBoxInput from 'common/components/base/forms/Checkbox/CheckBoxInput'

export const InventoryScanPage: React.FC = () => {
  const { t } = useTranslation()

  const currentSubcoId = useSelector(getCurrentSubcoId)
  const isBatchHubOutDone = useSelector(getIsBatchHubOutDone)

  const [isPageAllowed, setIsPageallowed] = React.useState<boolean | null>(null)
  const classes = useStyles()

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      const current = moment()
      const currentHour = current.hour()
      if (currentHour > 3 && currentHour < 15) {
        setIsPageallowed(true)
      } else {
        setIsPageallowed(false)
      }
    }, 1000)
    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [])

  const handleBatchHubOut = async (data: any) => {
    await batchHubOut(data.payload, true)
  }

  const [modalOpen, setModalOpen] = React.useState(true)
  const [hasAcknowledged, setHasAcknowledged] = React.useState(false)
  const [canStartScan, setCanStartScan] = React.useState(false)

  const handleAcknowledgeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setHasAcknowledged(event.target.checked)
  }

  const handleStartScan = () => {
    setCanStartScan(true)
    setModalOpen(false)
  }

  if (!isPageAllowed) {
    return (
      <div className="mt-20">
        <InventoryScanDisabled />
      </div>
    )
  }

  return (
    <>
      <Dialog.Root open={modalOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-indigo-scrim opacity-60" />
          <Dialog.Content className="fixed inset-0 m-auto h-fit w-full max-w-[584px] rounded-md bg-white p-6 shadow-elevation-2 animate-fade-up">
            <div className="flex items-center mb-4">
              <div className="mr-4">
                <Snowflake className={classes.snowflakeIcon} />
              </div>
              <Dialog.Title className="font-heading text-h3 m-0">
                {t('FREEZER_WARNING.TITLE')}
              </Dialog.Title>
            </div>

            <Dialog.Description className="font-body text-md mb-6">
              {t('FREEZER_WARNING.TEXT')}
            </Dialog.Description>

            <div className="mb-8">
              <label className="flex items-center cursor-pointer">
                <CheckBoxInput
                  checked={hasAcknowledged}
                  onChange={handleAcknowledgeChange}
                  className="w-5 h-5 rounded border-gray-50 text-violet-50 focus:ring-violet-50 focus:ring-2 cursor-pointer"
                />
                <span className="ml-3 font-body text-md">
                  {t('FREEZER_WARNING.ACKNOWLEDGEMENT')}
                </span>
              </label>
            </div>

            <div className="flex justify-end">
              <Button
                primary
                onClick={handleStartScan}
                disabled={!hasAcknowledged}
              >
                {t('FREEZER_WARNING.START_SCAN')}
              </Button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
      {canStartScan && (
        <InventoryScan
          t={t}
          trans={Trans}
          subcoId={currentSubcoId}
          className={classes.inventoryScan}
          onBatchHubOut={handleBatchHubOut}
          isBatchHubOutDone={isBatchHubOutDone}
        />
      )}
    </>
  )
}

export default InventoryScanPage
